import { initialEnrollmentDetails, saveSession, useCaregiverWizardUpdateDispatch } from 'ContextProviders/CaregiverWizard'
import { useRef, useState } from 'react'
import { type PortalLocation, type EnrollmentDetails, type ReferralTimeFrame } from 'core/types'
import { useParams } from 'react-router'
import { useScrollTop } from 'hooks/use-scrollTop'
import { ServiceProviderMapSelect, type ServiceProviderOption } from 'Pages/CaregiverPortal/Components/ServiceProviderMapSelect'

interface ServiceProviderMapProps {
  caregiverForm: EnrollmentDetails
  maxProviders?: number
  handleStep: (backwards: boolean) => void
}

export function ServiceProviderMap (props: ServiceProviderMapProps): JSX.Element {
  const dispatch = useCaregiverWizardUpdateDispatch()
  const { isdId } = useParams()
  const serviceID = useRef<number | null>(props.caregiverForm?.currentChild?.requestedServices?.find(s => s.isCurrentlyUpdating)?.id ?? null)
  const [location, setLocation] = useState<PortalLocation>(props.caregiverForm.currentChild.location)
  useScrollTop()

  const caregiverForm = props.caregiverForm

  if (caregiverForm.currentChild.livesWithFirstChild === true) {
    setLocation(caregiverForm.children[0].location)
  }

  const handleSpecificProviderClick = async (): Promise<void> => {
    const tempForm = { ...caregiverForm, currentSubStep: 1 }
    await saveSession(tempForm)
    dispatch({ type: 'form', form: tempForm })
  }

  const handleBack = async (): Promise<void> => {
    const tempForm = { ...caregiverForm, currentStep: 3, currentSubStep: 3 }
    await saveSession(tempForm)
    props.handleStep(true)
    dispatch({ type: 'form', form: tempForm })
  }

  const handleContinue = async (selectedProviders: ServiceProviderOption[]): Promise<void> => {
    if (props.maxProviders !== undefined && selectedProviders.length > props.maxProviders) {
      return
    }

    const tempForm = { ...caregiverForm, currentSubStep: 3 }
    const tempChild = { ...tempForm.currentChild }
    const currentService = tempChild.requestedServices?.find(s => s.isCurrentlyUpdating)
    if (currentService != null) {
      currentService.facilityIds = selectedProviders.map(p => p.id)
    }
    const existingChildIndex = tempForm.children.findIndex(c => c.isCurrentlyUpdating)
    if (existingChildIndex !== -1) {
      tempChild.isCurrentlyUpdating = false
      const service = tempChild.requestedServices?.find(s => s.isCurrentlyUpdating)
      if (service != null) {
        service.isCurrentlyUpdating = false
      }
      tempForm.children[existingChildIndex] = tempChild
    }
    const initialForm = initialEnrollmentDetails()
    tempForm.currentChild = initialForm.currentChild

    await saveSession(tempForm)
    dispatch({ type: 'form', form: tempForm })
  }

  const srvs = props.caregiverForm.currentChild.requestedServices

  let rtf: ReferralTimeFrame | null = null
  if (srvs != null && srvs?.length > 0) {
    rtf = srvs[0].timeFrame
  }
  return <ServiceProviderMapSelect childDOB={caregiverForm.currentChild.dateOfBirth} timeFrame={rtf}
    childLocation={location} isdId={Number(isdId)}
    serviceId={serviceID.current ?? 0} isdServiceProviderId={null} selectedProviders={[]} handleBack={handleBack} handleContinue={handleContinue}
    handleSpecificProviderClick={handleSpecificProviderClick} maxProviders={props.maxProviders}
  />
}
